import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {AppBar, Box, Toolbar, Button} from '@mui/material';
import s3kLogo from '../images/s3k-logo-alt2-512.png';
import lionheartLogo from '../images/lionheart-logo.png';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";


import Sidebar from '../components/Sidebar';
import { useIsMobile } from '../hooks/useIsMobile';

export default function LionheartAppbar() {
    // Navigation hook
    const navigate = useNavigate();

    // State for Sidebar
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    // State for mobile sensing
    const isMobile = useIsMobile();


    // Toggle Sidebar
    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={(theme) => ({})}>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{
                height: isMobile ? "40px" : "80px",
                width: isMobile ? "40px" : "80px",
              }}
            >
              <img
                src={s3kLogo}
                alt="S3K Logo"
                style={{ width: 40, height: 40, borderRadius: 0 }}
              />
            </Button>
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <Button
                variant="text"
                onClick={() => navigate("/")}
                sx={{
                  height: isMobile ? "70px" : "90px",
                }}
              >
                <img
                  src={lionheartLogo}
                  alt="Lionheart Logo"
                  style={{
                    height: isMobile ? "60px" : "100px",
                    borderRadius: 0,
                  }}
                />
              </Button>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                color="inherit"
                startIcon={<AccountCircleIcon />}
                onClick={() => navigate("/profile")}
                sx={{
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: isMobile ? "0.85rem" : "1rem",
                }}
              >
                {!isMobile && "Profile"}
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Include Sidebar Component */}
        <Sidebar isOpen={isDrawerOpen} toggleSidebar={toggleDrawer} />
      </Box>
    );
}
